import { Tag as ANTDTag } from 'antd';
import styled from 'styled-components';

export const Tag = styled(ANTDTag)`
  background: var(--neutral_lightest);
  border: 1px solid var(--neutral_lighter);
  color: var(--neutral_medium);
  font-weight: normal;
  border-radius: 2px;
  &.rounded {
    border-radius: 10px;
  }
  &.exempt {
    background: var(--green-sea_lighter);
    color: var(--brand-deep-green);
    border-color: var(--green-sea_light);
  }
  &.error {
    border: 1px solid var(--error-light);
    color: var(--error-medium);
  }
  &.due-status {
    &.released {
      background: var(--green-sea_lighter);
      color: var(--green-sea_dark);
      border-color: var(--green-sea_light);
    }
    &.delivered {
      background: var(--success-lightest);
      color: var(--success-dark);
      border-color: var(--success-light);
    }
    &.outdated {
      background: var(--error-lightest);
      color: var(--error-medium);
      border-color: var(--error-light);
    }
  }
  &.charge-status {
    &.unbilled {
      border-color: var(--neutral_medium);
    }
    &.archived {
      background: var(--neutral_lighter);
      color: var(--neutral_dark);
      border-color: var(--neutral_medium);
    }
    &.billing {
      background: var(--warning-lightest);
      color: var(--warning-dark);
      border-color: var(--warning-light);
    }
    &.billed {
      border-color: var(--ocean_lighter);
    }
    &.rebilled {
      border-color: var(--ocean_lighter);
    }
    &.reversed {
      background: var(--error-lightest);
      color: var(--error-medium);
      border-color: var(--error-light);
    }
    &.processing {
      background: var(--info-lighter);
      color: var(--info-dark);
      border-color: var(--info-light);
    }
    &.send-error {
      background: var(--error-dark);
      color: #fff;
      border-color: var(--error-dark);
    }
  }
  /* Os dois vermelhos e os dois verdes se distinguem por preenchimento, não só
     por tom: os estados avançados do ciclo (confirmado, erro no envio, arquivado)
     são sólidos. */
  &.docking-billing-status {
    &.unknown {
      border-color: var(--neutral_medium);
    }
    /* Cinza, e não azul claro, para não competir com o azul de
       sent-to-invoicing; o preenchimento a separa do estado neutro. */
    &.awaiting-report {
      background: var(--neutral_lighter);
      color: var(--neutral_dark);
      border-color: var(--neutral_light);
    }
    &.report-overdue {
      background: var(--error-lightest);
      color: var(--error-medium);
      border-color: var(--error-light);
    }
    &.operation-finished {
      background: var(--success-lightest);
      color: var(--success-dark);
      border-color: var(--success-light);
    }
    &.sent-to-invoicing {
      background: var(--info-lighter);
      color: var(--info-dark);
      border-color: var(--info-light);
    }
    &.processing-by-finance {
      background: var(--warning-lightest);
      color: var(--warning-dark);
      border-color: var(--warning-light);
    }
    &.confirmed-by-finance {
      background: var(--success-dark);
      color: #fff;
      border-color: var(--success-dark);
    }
    &.finance-send-error {
      background: var(--error-dark);
      color: #fff;
      border-color: var(--error-dark);
    }
    &.archived {
      background: var(--neutral_medium);
      color: #fff;
      border-color: var(--neutral_medium);
    }
    /* A única sem preenchimento: o fundeio não está em etapa nenhuma do
       ciclo, e um fundo a colocaria em pé de igualdade com quem está. */
    &.not-billable {
      background: transparent;
      color: var(--neutral_medium);
      border-color: var(--neutral_light);
    }
  }
  &.storage-status {
    &.confirmed {
      background: var(--success-lightest);
      color: var(--success-dark);
      border-color: var(--success-light);
    }
    &.rejected {
      background: var(--error-lightest);
      color: var(--error-medium);
      border-color: var(--error-light);
    }
    &.pending {
      background: var(--warning-lightest);
      color: var(--warning-dark);
      border-color: var(--warning-light);
    }
    &.new-schedule {
      background: var(--info-lighter);
      color: var(--info-dark);
      border-color: var(--info-light);
    }
  }
  &.pumping-berth {
    height: 22px;
    &.pgl-1 {
      background: var(--neutral_lightest);
      color: var(--neutral_medium);
      border-color: var(--neutral_lighter);
    }
    &.pgl-2 {
      background: var(--ocean_lighter);
      color: var(--ocean_dark);
      border-color: var(--ocean_light);
    }
    &.pgl-3a {
      background: var(--neutral_lighter);
      color: var(--neutral_medium);
      border-color: var(--neutral_light);
    }
    &.pgl-3b {
      background: var(--neutral_medium);
      color: var(--neutral_lightest);
      border-color: var(--neutral_light);
    }
    &.berth-1 {
      background: var(--ocean_light);
      color: #fff;
      border-color: var(--ocean_lighter);
    }
    &.berth-2 {
      background: var(--ocean_lighter);
      color: var(--ocean_dark);
      border-color: var(--ocean_light);
    }
    &.berth-3 {
      background: #f8fafb;
      color: #65737e;
      border-color: #dfe3e6;
    }
    &.berth-4 {
      background: #b2bec3;
      color: #fff;
      border-color: #c0c5ce;
    }
    &.berth-5 {
      background: #dfe6e9;
      color: #636e72;
      border-color: #b2bec3;
    }
    &.berth-6 {
      background: #c0c5ce;
      color: #65737e;
      border-color: #a7adba;
    }
    &.berth-7 {
      background: #65737e;
      color: #fff;
      border-color: #c0c5ce;
    }
  }
`;
